<template>
    <div class="main">

            <b-navbar toggleable="lg" type="dark" variant="dark">
                <b-navbar-brand class="text-light" href="#">LabyHelp Addon</b-navbar-brand>
                -
                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                <b-collapse id="nav-collapse" is-nav>
                    <b-navbar-nav>
                        <b-nav-item style="color: #c2c2c2" href="#">
                            <router-link style="color: #c2c2c2" to="/home">Home</router-link>
                        </b-nav-item>
                        <b-nav-item to="/home#features" style="color: #c2c2c2">Features
                        </b-nav-item>
                        <b-nav-item href="#features" style="color: #ffffff">
                            <router-link style="color: #ffffff" to="/support">Support</router-link>
                        </b-nav-item>
                        <b-nav-item href="#features" style="color: #c2c2c2" to="/creator">
                            Creator Program
                        </b-nav-item>
                    </b-navbar-nav>

                    <!-- Right aligned nav items -->

                </b-collapse>
            </b-navbar>

        <br/>
        <br/>

        <h1 class="text-normal-title"><fai style="color:black;" :icon="['fas', 'question-circle']" size="1x"/> Häufig Gestellte Fragen</h1>

            <p class="text-title text-dark">Die häufigsten Fragen die in der LabyHelp Community gefragt wurden.</p>



        <div class="container" id="features">

            <br/>

            <br/>

            <div style="color: #164fb4">
                <h4><a style="color: #4949ef" v-b-toggle.collapse-0 class="m-1 text-dark text-primary">- Wie installiere ich das Addon?</a></h4>
                <b-collapse visible id="collapse-0">
                    <b-card>
                        Führe die Datei mit einem Doppelklick aus und folge dann das Installations Program. Wenn sich kein Installations Program öffnet dann befolge die 7 Schritte unter diesem Artikel.

                    </b-card>
                </b-collapse>
            </div>

            <br/>

            <div style="color: #164fb4">
                <h4><a style="color: #4949ef" v-b-toggle.collapse-1 class="m-1 text-dark text-primary">- Was mache ich wenn sich die Datei nicht öffnen lässt?</a></h4>
                <b-collapse visible id="collapse-1">
                    <b-card>Schritt 0. Schließe Minecraft
                        <br/>
                        Schritt 1. Drücke |WINDOWS TASTE|  + |R|
                        <br/>
                        Schritt 2. Gebe %appdata% in der Suchleiste ein
                        <br/>
                        Schritt 3. Drücke auf "Ok"
                        <br/>
                        Schritt 4. Öffne den ".minecraft" Ordner
                        <br/>
                        Schritt 5. Öffne den "LabyMod" Ordner
                        <br/>
                        Schritt 6. Öffne den Ordner "addons-1.8" und "addons-1.12"
                        <br/>
                        Schritt 7. Schiebe die Jar Datei in die beiden Ordner. Starte dann Minecraft neu</b-card>
                </b-collapse>
            </div>

            <br/>

            <div style="color: #164fb4">
                <h4><a style="color: #4949ef" v-b-toggle.collapse-100 class="m-1 text-dark text-primary">- Welche LabyHelp Befehle existieren?</a></h4>
                <b-collapse visible id="collapse-100">
                    <b-card>

                        <strong>Skin:</strong>
                        - /bandana (player)
                        - /cape (player)
                        - /skin (player)
                        <br/>
                        <strong>Social:</strong>
                        - /insta (player)
                        - /discord (player)
                        - /youtube (player)
                        - /twitch (player)
                        - /tiktok (player)
                        - /twitter (player)
                        - /snapchat (player)
                        - /social (player)
                        <br/>
                        <strong>Liken / Inviten:</strong>
                        - /lhlike (player)
                        - /likes
                        - /likelist
                        - /invites (player)
                        - /invitelist
                        - /lhcomment
                        - /showcomments (player)
                        <br/>
                        <strong>LabyHelp:</strong>
                        - /lhteam
                        - /lhaddons
                        - /lhrules
                        - /lhreload
                        - /labyhelp

                    </b-card>
                </b-collapse>
            </div>

            <br/>

            <div style="color: #164fb4">
                <h4><a style="color: #4949ef" v-b-toggle.collapse-2 class="m-1 text-dark text-primary"> - Wo finde ich die Einstellungs Möglichkeiten?</a></h4>
                <b-collapse visible id="collapse-2">
                    <b-card>
                        Die LabyHelp Einstellungen findest du unter Optionen -> LabyMod Einstellungen -> Addons und dann auf dem LabyHelp Addon Einstellungs Icon.

                    </b-card>
                </b-collapse>
            </div>

            <br/>

            <div style="color: #164fb4">
                <h4><a style="color: #4949ef" v-b-toggle.collapse-200 class="m-1 text-dark text-primary"> - Wie ändere oder setze ich meinen Instagram/Discord Namen?</a></h4>
                <b-collapse visible id="collapse-200">
                    <b-card>
                        Gehe in die Einstellungs Möglichkeiten wie es oben beschrieben wird dann suche den Punkt Instagram/Discord username auf und setze oder ändere deinen Namen auf der rechten Seite. (Discord Beispiel: DiscordNamen + #0000)

                    </b-card>
                </b-collapse>
            </div>

            <br/>

            <div style="color: #164fb4">
                <h4><a style="color: #4949ef" v-b-toggle.collapse-70 class="m-1 text-dark text-primary"> - Datei lässt sich nicht öffnen anderer Versuch</a></h4>
                <b-collapse visible id="collapse-70">
                    <b-card>
                        Installiere dir Jarfix und probiere es erneut <a href="https://johann.loefflmann.net/downloads/jarfix.exe" target="_blank" style="color: #000000">(Download)</a>

                    </b-card>
                </b-collapse>
            </div>

            <br/>

            <div style="color: #164fb4">
                <h4><a style="color: #4949ef" v-b-toggle.collapse-5 class="m-1 text-dark text-primary"> - Wo befindet sich der Download?</a></h4>
                <b-collapse visible id="collapse-5">
                    <b-card>
                        Auf der Home Seite unter Download findest du immer die aktuelle Version. <a href="/download" style="color: #000000">(Download)</a>

                    </b-card>
                </b-collapse>
            </div>

            <br class="no-move"/>

            <h2 class="text-normal-title">Der LabyHelp Discord</h2>

            <div class="deck2-class">
                <br class="no-move"/>

            <p class="normal-text text-white">Du hast Fragen die hier nicht stehen dann melde dich auf unseren Discord.</p>
            <br/>

            <iframe src="https://discordapp.com/widget?id=736693312278233170&theme=dark" width="550" height="500" allowtransparency="true" frameborder="0"
                    sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"></iframe>

                <br class="no-move"/>

            <br/>
            <br/>

            </div>

            <br class="no-move"/>
            <br class="no-move"/>
            <br class="no-move"/>

        </div>

        <div class="end" style="background-color: #e0e0e0">
            <br/>

            <h1 class="text-dark"><strong>Du hast immer noch <em>Fragen?</em></strong></h1>
            <p class="text-title text-dark">Dann hast du hier eine weitere Kontakt Möglichkeit</p>

            <br/>
            <b-button href="mailto:support@labyhelp.de"
                      title="download labyhelp addon" pill type="button" class="btn btn-dark btn-lg"><strong>Support</strong>
            </b-button>
            <br/>
            <br/>
            <br/>

        </div>


        <div class="footer">
            <p class="align-text-bottom">
              <a style="color: white" href="https://labyhelp.de/imprint">Impressum</a>
                -
                <a style="color: white"
                   href="/download">Download</a>
                -
                <a style="color: white" href="https://discord.gg/PBqQT9C">Discord</a>
                -
                <a style="color: white" href="/home">Home</a>
                -
                <router-link style="color: white" to="/apply">Apply</router-link>
                -
                <router-link style="color: white" to="/rules">Regeln</router-link>
                <br/>
                © LabyHelp 2020
            </p>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'labyaddon'
    }

</script>